import { DsText } from "../components/ui";
import { classNames } from "../utils/classNames";

export type OptionType<T> = {
  label: string;
  value: T;
};

export type DriverTaskOptionsSelectorPropsType<T> = {
  options: OptionType<T>[];
  onSelect: (value: T) => void;
  value: T;
};

const DriverTaskOptionsSelector = <T,>({
  options,
  onSelect,
  value,
}: DriverTaskOptionsSelectorPropsType<T>) => {
  return (
    <div className="flex flex-row gap-1">
      {options.map(option => {
        const isSelected = value === option.value;

        return (
          <div
            key={option.value as string}
            className={classNames(
              "flex-grow text-center items-center h-28 rounded-2xl w-full md:w-32 p-2 border border-gray-300 flex flex-col justify-center px-2 hover:cursor-pointer bg-white",
              isSelected && "bg-sos-yellow border-sos-yellow",
            )}
            onClick={() => onSelect(option.value)}>
            <DsText
              variant="selectableOption"
              className={classNames(isSelected && "text-black")}>
              {option.label}
            </DsText>
          </div>
        );
      })}
    </div>
  );
};

export { DriverTaskOptionsSelector };
